<!-- <button class="btn btn-cont cont-1" id="btn_menos" (click)="changeCount('remove')">─</button>
<input id="cont" type="number" class="fs-9 input-num color-2 " value="{{quantity}}">
<button class="btn btn-cont cont-2" id="btn_mas" (click)="changeCount('add')">+</button> -->

<button class="btn btn-success btn-sm" [disabled]="quantity > 0" id="btn_mas" (click)="changeCount('add')"><i class="fas fa-cart-plus"></i>&nbsp;{{'COMMON.Add' | translate}}</button>